import {createSelector} from "reselect";
import {Pipeline, PipelineEntity} from "../../../model/pipeline/pipeline";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";

export type PipelineSelectorProps = {
    regionId?: string
    showInactive?: boolean;
};

const getRegionIdParam = createParamSelector<PipelineSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getShowInactiveParam = createParamSelector<PipelineSelectorProps | undefined, boolean | undefined>(params => params?.showInactive);

export const pipelinesSelector = () => createSelector(
    [getUseQueryResultData<Pipeline[]>, getRegionIdParam, getShowInactiveParam],
    (data, regionId, showInactive) => {
        return selectPipelinesAndTransform(
            data ?? [], {
                regionId: regionId,
                showInactive: showInactive
            }
        );
    }
);

export const pipelineSelector = () => createSelector(
    [getUseQueryResultData<Pipeline>],
    (data) => {
        return data ? transformPipeline(data) : undefined;
    }
);

export const selectPipelines = (values?: Pipeline[], selector?: PipelineSelectorProps): Pipeline[] => {
    if (!values) {
        return [];
    }

    return values.filter((v) => {
        let filterIn = true;

        if (selector?.regionId) {
            if (selector.regionId !== v.regionId) {
                filterIn = false
            }
        }

        const showInactive = selector?.showInactive ?? true;
        if (filterIn && !showInactive && typeof v.inactiveDttm !== "undefined") {
            filterIn = false;
        }

        return filterIn;
    });
};

export const transformPipeline = (value: Pipeline): PipelineEntity => {
    return PipelineEntity.from(value)
}

export const selectPipelinesAndTransform = (values?: Pipeline[], selector?: PipelineSelectorProps): PipelineEntity[] => {
    const selected = selectPipelines(values, selector);
    return selected.map(transformPipeline);
};
